<mat-form-field>
  <mat-label>Paste Excel Here</mat-label>
  <input
    matInput
    readonly
    (paste)="onPaste($event)"
  />
</mat-form-field>